import { WWW_URLS                   }  from '../../backendServices/urls';
import { Product                    ,
         ProductVariant             ,
		 ProductPrice               ,
		 ProductDiscount            ,
		 ProductCharacteristic      ,
		 ProductMedia               }  from './types';

/*
export const searchImage = (product: Product): string => {
 
    let imgFile = "";
	
	for ( let c = 0; c < product.characteristics.length; c++)
	 {
	  if ( product.characteristics[c].kind === "Photo" )
	   {
	    imgFile = product.characteristics[c].value !== null ? (product.characteristics[c].value as string) : "";
		break;
	   }
	 }
	 
    if ( imgFile === "" )
     {
	  for ( let v = 0; v < product.variants.length; v++)
	   {
  	    for ( let c = 0; c < product.variants[v].characteristics.length; c++)
	     {
	      if ( product.variants[v].characteristics[c].kind === "Photo" )
	       {
	        imgFile = product.variants[v].characteristics[c].value !== null ? (product.variants[v].characteristics[c].value as string) : "";
		    break;
	       }
	     }
	  
        if ( imgFile !== "" )
         {
	      break;
	     }	  
	   }
     }
	 
    return    `${WWW_URLS.ProductThumbnail}${imgFile}`;  //imgFile
  }
  */
  
export const searchImage = async ( product:         Product     ,
                                   selectedVariant: number  = 0 ,
								   selectedImage:   number  = 0 ) : Promise<string> => {

/*
  let imgFile = "";
  let result: string = ""
  
  console.log ( "searchImage", product)

  if ( product.associatedMediaId === 0 && product.associatedBroadcastingChannelId === 0 )
        {
         console.log ( "searchImage cas 1", product)


         // Recherche dans les caractéristiques du produit
         for (let c = 0; c < product.characteristics.length; c++) 
		  {
           if (product.characteristics[c].kind === "Photo") 
		    {
             imgFile = product.characteristics[c].value ? (product.characteristics[c].value as string) : "";
             break;
            }
          }

         // Si aucune image n'est trouvée, recherche dans les variantes
         if (imgFile === "") 
		  {
           for (let v = 0; v < product.variants.length; v++) 
		    {
             for (let c = 0; c < product.variants[v].characteristics.length; c++) 
			  {
               if (product.variants[v].characteristics[c].kind === "Photo") 
			    {
                 imgFile = product.variants[v].characteristics[c].value ? (product.variants[v].characteristics[c].value as string) : "";
                 break;
                }
              }
             if (imgFile !== "") 
			  {
               break;
              }
            }
          }

         result = imgFile ? `${WWW_URLS.ProductThumbnail}${imgFile}` : "";
        }
   else {
         console.log ( "searchImage cas 2", product)
	   
	     if ( product.associatedMediaId !== 0 )
		       {
	            const response = await getMediaById ( product.associatedMediaId )

         console.log ( "searchImage cas 2a", product, response)


		        if ( response.code === 1 )
		              {
   		               const mediaThumbnail = ( response.payload as Video ).imageFile
		   
                       result = `${WWW_URLS.Thumbnail}${mediaThumbnail}.webp`;
		              }
		         else {
			           result = ""
		              }
			   }
		  else {
	            if ( product.associatedBroadcastingChannelId !== 0 )
		              {
	                   const response = await getBroadcastingChannelById ( product.associatedBroadcastingChannelId )

         console.log ( "searchImage cas 2b", product, response)

		               if ( response.code === 1 )
		                     {
   		                      const broadcastingChannelLogo = ( response.payload as BroadcastingChannel ).logoImageFile
		   
                              result = `${WWW_URLS.ThumbnailChannel}${broadcastingChannelLogo}.webp`;
		                     }
		                else {
			                  result = ""
		                     }
			          }
		         else {
	                   result = ""
		              }
		       }
        }
		
  return result
  */
  
  
  const cptStr = (selectedImage+1).toString().padStart(4, "0")				   
  const image  = product.publicRef !== '' ? `${WWW_URLS.MediaServer}${product.publicRef}/images/${product.variants[selectedVariant].code}-${cptStr}_BIG.webp` : ''

  console.log ( 'searchImage ', product, selectedVariant, selectedImage, image )
	  
  return image
};
  
  
export const searchImages = (product: Product): string [] => {
 
    let imgFiles: string [] = [];
	
	for ( let c = 0; c < product.characteristics.length; c++)
	 {
	  if ( product.characteristics[c].kind === "Photo" )
	   {
	    if ( product.characteristics[c].value !== null )
		      {
	           imgFiles.push ( `${WWW_URLS.ProductThumbnail}${(product.characteristics[c].value as string)}` );
		      }
		 else {
	           imgFiles.push ( `${WWW_URLS.ProductThumbnail}` );
		      }
	   }
	 }
	 
    for ( let v = 0; v < product.variants.length; v++)
	 {
  	  for ( let c = 0; c < product.variants[v].characteristics.length; c++)
	   {
	    if ( product.variants[v].characteristics[c].kind === "Photo" )
	     {
	      if ( product.characteristics[c].value !== null )
		      {
  	           imgFiles.push ( `${WWW_URLS.ProductThumbnail}${(product.variants[v].characteristics[c].value as string)}` );
		      }
		 else {
	           imgFiles.push ( `${WWW_URLS.ProductThumbnail}` );
		      }         }
	   }
     }
	 
    return imgFiles
  }

export const compareCharacteristic = ( characteristicA: ProductCharacteristic , 
                                       characteristicB: ProductCharacteristic ): boolean => {
	
  const result = ( characteristicA.name        === characteristicA.name        ) && 
                 ( characteristicA.kind        === characteristicA.kind        ) &&
                 ( characteristicA.unit        === characteristicA.unit        ) &&
                 ( characteristicA.value       === characteristicA.value       ) 
		 
  return result
}

export const compareDiscount = ( discountA: ProductDiscount , 
                                 discountB: ProductDiscount ): boolean => {
	
	
  const result = ( discountA.type           === discountB.type           ) && 
                 ( discountA.condition      === discountB.condition      ) &&
                 ( discountA.value          === discountB.value          ) &&
                 ( discountA.active         === discountB.active         ) && 
                 ( discountA.priceToApplyOn === discountB.priceToApplyOn ) &&
				 ( parseFloat(discountA.priceToPay.toFixed(2))   === parseFloat(discountB.priceToPay.toFixed(2))   ) 

		 
  return result
}

export const comparePrice = ( priceA: ProductPrice , 
                              priceB: ProductPrice ): boolean => {


  let testDiscountArray = priceA.discounts.length === priceB.discounts.length

  if ( testDiscountArray )
   {
    for ( let i=0 ; i < priceA.discounts.length ; i++ )
     {
	  testDiscountArray = testDiscountArray && compareDiscount ( priceA.discounts[i] , priceB.discounts[i] )
	  
	  if ( !testDiscountArray )
	   {
		break;
	   }
	 }  
   }
	
  const result = ( priceA.name           === priceB.name           ) && 
                 ( priceA.requiredStatus === priceB.requiredStatus ) &&
                 ( priceA.comment        === priceB.comment        ) &&
                 ( priceA.code           === priceB.code           ) && 
                 ( priceA.active         === priceB.active         ) && 
               //  ( priceA.creationDate   === priceB.creationDate   ) && 
                 ( parseFloat(priceA.basePrice.toFixed(2))    === parseFloat(priceB.basePrice.toFixed(2))    ) && 
                 ( parseFloat(priceA.taxRate.toFixed(2))      === parseFloat(priceB.taxRate.toFixed(2))      ) && 
                 ( parseFloat(priceA.priceWithTax.toFixed(2)) === parseFloat(priceB.priceWithTax.toFixed(2)) ) && testDiscountArray
		 
  return result		
}

/*
export const compareProductVariant = ( productVariantA: ProductVariant , 
                                       productVariantB: ProductVariant ): boolean => {


  let testPriceArray = productVariantA.prices.length === productVariantB.prices.length

  if ( testPriceArray )
   {
    for ( let i=0 ; i < productVariantA.prices.length ; i++ )
     {
	  testPriceArray = testPriceArray && comparePrice ( productVariantA.prices[i] , productVariantB.prices[i] )
	  
	  if ( !testPriceArray )
	   {
		break;
	   }
	 }  
   }
	
  let testCharacteristicArray = productVariantA.characteristics.length === productVariantB.characteristics.length

  if ( testCharacteristicArray )
   {
    for ( let i=0 ; i < productVariantA.characteristics.length ; i++ )
     {
	  testCharacteristicArray = testCharacteristicArray && compareCharacteristic ( productVariantA.characteristics[i] , productVariantB.characteristics[i] )
	  
	  if ( !testCharacteristicArray )
	   {
		break;
	   }
	 }  
   }
	
  const result = ( productVariantA.name           === productVariantB.name           ) && 
                 ( productVariantA.complement     === productVariantB.complement     ) &&
                 ( productVariantA.description    === productVariantB.description    ) &&
                 ( productVariantA.code           === productVariantB.code           ) && 
                 ( productVariantA.barcode        === productVariantB.barcode        ) && 
                 ( productVariantA.stockAvailable === productVariantB.stockAvailable ) && 
                 ( productVariantA.stockBooked    === productVariantB.stockBooked    ) && 
                 ( productVariantA.stockAssigned  === productVariantB.stockAssigned  ) && 
        //       ( productVariantA.creationDate   === productVariantB.creationDate   ) &&
                 ( productVariantA.stockThreshold === productVariantB.stockThreshold ) && testPriceArray
		                                                                               && testCharacteristicArray 

  return result
}
*/

export const compareMedia = (mediaA: ProductMedia, mediaB: ProductMedia): boolean => {
  const result = (
    mediaA.name === mediaB.name &&
    mediaA.rank === mediaB.rank &&
    mediaA.publicFileName === mediaB.publicFileName &&
    mediaA.privateFileName === mediaB.privateFileName &&
    mediaA.asThumbnail === mediaB.asThumbnail &&
    mediaA.mediaType === mediaB.mediaType &&
    // On ne compare pas fileContent car c'est un File qui peut changer
    (mediaA.fileContent === null) === (mediaB.fileContent === null)
  );
  
  return result;
};

// Puis modifiez la fonction compareProductVariant dans utils.ts pour inclure les médias :
export const compareProductVariant = (
  productVariantA: ProductVariant,
  productVariantB: ProductVariant
): boolean => {
  let testPriceArray = productVariantA.prices.length === productVariantB.prices.length;

  if (testPriceArray) {
    for (let i = 0; i < productVariantA.prices.length; i++) {
      testPriceArray = testPriceArray && comparePrice(productVariantA.prices[i], productVariantB.prices[i]);
      if (!testPriceArray) break;
    }
  }

  let testCharacteristicArray = productVariantA.characteristics.length === productVariantB.characteristics.length;

  if (testCharacteristicArray) {
    for (let i = 0; i < productVariantA.characteristics.length; i++) {
      testCharacteristicArray = testCharacteristicArray && 
        compareCharacteristic(productVariantA.characteristics[i], productVariantB.characteristics[i]);
      if (!testCharacteristicArray) break;
    }
  }

  // Ajout de la comparaison des médias
  let testMediaArray = productVariantA.medias.length === productVariantB.medias.length;

  if (testMediaArray) {
    for (let i = 0; i < productVariantA.medias.length; i++) {
      testMediaArray = testMediaArray && 
        compareMedia(productVariantA.medias[i], productVariantB.medias[i]);
      if (!testMediaArray) break;
    }
  }

  const result = (
    productVariantA.name === productVariantB.name &&
    productVariantA.complement === productVariantB.complement &&
    productVariantA.description === productVariantB.description &&
    productVariantA.code === productVariantB.code &&
    productVariantA.barcode === productVariantB.barcode &&
    productVariantA.stockAvailable === productVariantB.stockAvailable &&
    productVariantA.stockBooked === productVariantB.stockBooked &&
    productVariantA.stockAssigned === productVariantB.stockAssigned &&
    productVariantA.stockThreshold === productVariantB.stockThreshold &&
    testPriceArray &&
    testCharacteristicArray &&
    testMediaArray
  );

  return result;
};

export const compareProduct = ( productA: Product , 
                                productB: Product ): boolean => {

  let testProductVariantArray = productA.variants.length === productB.variants.length

  if ( testProductVariantArray )
   {
    for ( let i=0 ; i < productA.variants.length ; i++ )
     {
	  testProductVariantArray = testProductVariantArray && compareProductVariant ( productA.variants[i] , productB.variants[i] )
	  
	  if ( !testProductVariantArray )
	   {
		break;
	   }
	 }  
   }
	
  let testCharacteristicArray = productA.characteristics.length === productB.characteristics.length

  if ( testCharacteristicArray )
   {
    for ( let i=0 ; i < productA.characteristics.length ; i++ )
     {
	  testCharacteristicArray = testCharacteristicArray && compareCharacteristic ( productA.characteristics[i] , productB.characteristics[i] )
	  
	  if ( !testCharacteristicArray )
	   {
		break;
	   }
	 }  
   }
	
  let testCategoriesIdsArray = productA.categoriesIds.length === productB.categoriesIds.length

  if ( testCategoriesIdsArray )
   {
    for ( let i=0 ; i < productA.categoriesIds.length ; i++ )
     {
	  testCategoriesIdsArray = testCategoriesIdsArray && ( productA.categoriesIds[i] === productB.categoriesIds[i] )
	  
	  if ( !testCategoriesIdsArray )
	   {
		break;
	   }
	 }  
   }
	
  const result = ( productA.name              === productB.name              ) && 
                 ( productA.catchword         === productB.catchword         ) &&
                 ( productA.code              === productB.code              ) && 
                 ( productA.active            === productB.active            ) && 
              // ( productA.creationDate      === productB.creationDate      ) && 
                 ( productA.requiredStatus    === productB.requiredStatus    ) && 
                 ( productA.paymentRequired   === productB.paymentRequired   ) && 
                 ( productA.kind              === productB.kind              ) && 
                 ( productA.description       === productB.description       ) && 
                 ( productA.associatedMediaId === productB.associatedMediaId ) && testProductVariantArray
	         	                                                               && testCharacteristicArray
									        								   && testCategoriesIdsArray

  return result																			   
}


export const getProductFromArray = ( id       : number | null ,
                                     products : Product []    ): Product | null => {
	  
  if ( id !== null && id !== 0 )
   {
    for (let l = 0; l < products.length; l++) 
     {
      if (products[l].id === id) 
       {
        return products[l];
       }
     }
   }
  return null;
};

export const getProductNameFromArray = ( id       : number     ,
                                         products : Product [] ): string => {

  for (let p = 0; p < products.length; p++) 
   {
    if (products[p].id === id) 
     {
      return products[p].name;
     }
   }
   
  return "";
};

export const getProductFirstPriceWithTaxFromArray = ( id       : number     ,
                                                      products : Product [] ): number => {

  for (let p = 0; p < products.length; p++) 
   {
    if (products[p].id === id) 
     {
      if ( products[p].variants.length > 0 ) 
       {
        if ( products[p].variants[0].prices.length > 0 ) 
         {
		  return products[p].variants[0].prices[0].priceWithTax
         }
       }		 
     }
   }
   
  return 0;
};


////////////////////////////////////////////////////////////////////////////////////////
/*
// Fonction pour valider les médias (photos)
export const validateMedias = (variants : ProductVariant [], variantExistence: boolean): { isValid: boolean; errorMessage: string } => {
  // Vérifier les médias du variant principal
  for (let i = 0; i < variants[0].medias.length; i++) {
    const media = variants[0].medias[i];
    if (!media.name || media.name.trim() === '') {
      return {
        isValid: false,
        errorMessage: `La photo n°${i + 1} n'a pas de nom`
      };
    }
    if (!media.fileContent && !media.publicFileName) {
      return {
        isValid: false,
        errorMessage: `La photo n°${i + 1} "${media.name}" n'a pas de fichier associé`
      };
    }
  }

  // Vérifier les médias des variants (si variants existent)
  if (variantExistence) {
    for (let v = 1; v < variants.length; v++) {
      for (let i = 0; i < variants[v].medias.length; i++) {
        const media = variants[v].medias[i];
        if (!media.name || media.name.trim() === '') {
          return {
            isValid: false,
            errorMessage: `La photo n°${i + 1} du variant n°${v} n'a pas de nom`
          };
        }
        if (!media.fileContent && !media.publicFileName) {
          return {
            isValid: false,
            errorMessage: `La photo n°${i + 1} "${media.name}" du variant n°${v} n'a pas de fichier associé`
          };
        }
      }
    }
  }

  return { isValid: true, errorMessage: '' };
};

// Fonction pour valider les caractéristiques
export const validateCharacteristics = (variants : ProductVariant [], variantExistence: boolean): { isValid: boolean; errorMessage: string } => {
  // Vérifier les caractéristiques du variant principal
  for (let i = 0; i < variants[0].characteristics.length; i++) {
    const char = variants[0].characteristics[i];
    if (!char.value || char.value.trim() === '') {
      return {
        isValid: false,
        errorMessage: `La caractéristique n°${i + 1} n'a pas de valeur`
      };
    }
    if ((char.kind === 'Dimension' || char.kind === 'Poids' || char.kind === 'Durée') && 
        (!char.name || char.name.trim() === '')) {
      return {
        isValid: false,
        errorMessage: `La caractéristique n°${i + 1} de type "${char.kind}" n'a pas de nom`
      };
    }
  }

  // Vérifier les caractéristiques des variants (si variants existent)
  if (variantExistence) {
    for (let v = 1; v < variants.length; v++) {
      for (let i = 0; i < variants[v].characteristics.length; i++) {
        const char = variants[v].characteristics[i];
        if (!char.value || char.value.trim() === '') {
          return {
            isValid: false,
            errorMessage: `La caractéristique n°${i + 1} du variant n°${v} n'a pas de valeur`
          };
        }
        if ((char.kind === 'Dimension' || char.kind === 'Poids' || char.kind === 'Durée') && 
            (!char.name || char.name.trim() === '')) {
          return {
            isValid: false,
            errorMessage: `La caractéristique n°${i + 1} de type "${char.kind}" du variant n°${v} n'a pas de nom`
          };
        }
      }
    }
  }

  return { isValid: true, errorMessage: '' };
};
*/